(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function bootWhenLibrariesReady(root, attempts) {
    if (window.gsap && window.ScrollTrigger) {
      boot(root);
      return;
    }
    if (attempts <= 0) return;
    setTimeout(function () { bootWhenLibrariesReady(root, attempts - 1); }, 80);
  }

  function boot(root) {
    if (root.dataset.cielReady === "true") return;
    root.dataset.cielReady = "true";

    gsap.registerPlugin(ScrollTrigger);

    const stage = root.querySelector(".ciel-scroll-stage");
    const videos = gsap.utils.toArray(root.querySelectorAll(".ciel-bg-video"));
    const chapters = gsap.utils.toArray(root.querySelectorAll(".ciel-chapter"));
    const dots = gsap.utils.toArray(root.querySelectorAll(".ciel-progress li"));
    const ghosts = gsap.utils.toArray(root.querySelectorAll(".ciel-ghost-numeral"));
    const cinemaTop = root.querySelector(".ciel-cinema-top");
    const cinemaBottom = root.querySelector(".ciel-cinema-bottom");
    const progressFill = root.querySelector(".ciel-progress-bar-fill");
    const tickerStack = root.querySelector(".ciel-ticker-stack");
    const cursorLight = root.querySelector(".ciel-cursor-light");
    const total = chapters.length;
    const fade = 0.22;
    let current = 0;

    if (!stage || !total) return;

    const clamp01 = function (n) { return Math.min(1, Math.max(0, n)); };

    requestAnimationFrame(function () { chapters[0].classList.add("is-active"); });
    videos.forEach(function (video) { video.play().catch(function () {}); });

    function paint(progress) {
      const segment = 1 / total;
      const idx = Math.min(total - 1, Math.floor(progress / segment));
      const local = clamp01((progress - idx * segment) / segment);
      const isLast = idx === total - 1;
      const videoT = isLast ? 0 : clamp01((local - (1 - fade)) / fade);
      const textOutT = isLast ? 0 : clamp01((local - (1 - fade)) / (fade * 0.65));
      const textInT = isLast ? 0 : clamp01((local - (1 - fade * 0.65)) / (fade * 0.65));

      videos.forEach(function (video, i) {
        let opacity;
        if (i < idx) opacity = 0;
        else if (i === idx) opacity = 1 - videoT;
        else if (i === idx + 1) opacity = videoT;
        else opacity = 0;
        video.style.opacity = opacity.toFixed(3);

        const shouldPlay = i === idx || (i === idx + 1 && videoT > 0);
        if (shouldPlay && video.paused) video.play().catch(function () {});
        else if (!shouldPlay && !video.paused) video.pause();
      });

      chapters.forEach(function (chapter, i) {
        let opacity;
        let translateY;
        if (i < idx) {
          opacity = 0;
          translateY = -60;
        } else if (i === idx) {
          opacity = 1 - textOutT;
          translateY = -textOutT * 60;
        } else if (i === idx + 1) {
          opacity = textInT;
          translateY = (1 - textInT) * 70;
        } else {
          opacity = 0;
          translateY = 70;
        }
        chapter.style.opacity = opacity.toFixed(3);
        chapter.style.transform = "translate3d(0, " + translateY.toFixed(2) + "px, 0)";
        if (opacity > 0.04 && !chapter.classList.contains("is-active")) chapter.classList.add("is-active");
      });

      ghosts.forEach(function (ghost, i) {
        const chapterIndex = i + 1;
        let chapterProgress = 0;
        if (chapterIndex === idx) chapterProgress = local;
        else if (chapterIndex === idx + 1) chapterProgress = -0.2 + 0.2 * videoT;
        else if (chapterIndex < idx) chapterProgress = 1;
        else chapterProgress = -0.2;
        ghost.style.transform = "translate3d(0, " + (-chapterProgress * 18).toFixed(2) + "vh, 0)";
      });

      const bandPeak = Math.max(textOutT - textInT * 0.4, textInT * 0.85);
      const barHeight = Math.min(1, Math.max(0, bandPeak)) * 36;
      if (cinemaTop) cinemaTop.style.height = barHeight.toFixed(2) + "px";
      if (cinemaBottom) cinemaBottom.style.height = barHeight.toFixed(2) + "px";
      if (progressFill) progressFill.style.transform = "scaleX(" + progress.toFixed(4) + ")";

      if (idx !== current) {
        if (dots[current]) dots[current].classList.remove("is-active");
        if (dots[idx]) dots[idx].classList.add("is-active");
        if (tickerStack) tickerStack.style.transform = "translateY(-" + idx + "em)";
        current = idx;
      }
    }

    ScrollTrigger.create({
      trigger: stage,
      start: "top top",
      end: "bottom bottom",
      scrub: true,
      onUpdate: function (self) { paint(self.progress); }
    });

    if (dots[0]) dots[0].classList.add("is-active");
    paint(0);

    const marqueeTrack = root.querySelector(".ciel-marquee-track");
    if (marqueeTrack) {
      const marqueeTween = gsap.to(marqueeTrack, {
        xPercent: -50,
        duration: 28,
        ease: "none",
        repeat: -1
      });
      let lastY = window.scrollY;
      let lastT = performance.now();
      window.addEventListener("scroll", function () {
        const now = performance.now();
        const y = window.scrollY;
        const velocity = Math.abs(y - lastY) / Math.max(16, now - lastT);
        const target = gsap.utils.clamp(0.6, 4.2, 1 + Math.abs(velocity) * 0.012);
        gsap.to(marqueeTween, { timeScale: target, duration: 0.6, overwrite: true });
        lastY = y;
        lastT = now;
      }, { passive: true });
    }

    if (window.matchMedia("(hover: hover)").matches && cursorLight) {
      const xTo = gsap.quickTo(cursorLight, "x", { duration: 0.55, ease: "power3" });
      const yTo = gsap.quickTo(cursorLight, "y", { duration: 0.55, ease: "power3" });
      let shown = false;
      window.addEventListener("pointermove", function (event) {
        if (!shown) {
          cursorLight.style.opacity = "1";
          shown = true;
        }
        xTo(event.clientX - window.innerWidth / 2);
        yTo(event.clientY - window.innerHeight / 2);
      }, { passive: true });
      window.addEventListener("pointerleave", function () {
        cursorLight.style.opacity = "0";
        shown = false;
      });
    }

    window.addEventListener("resize", function () { ScrollTrigger.refresh(); });
  }

  ready(function () {
    document.querySelectorAll("[data-ciel-home]").forEach(function (root) {
      bootWhenLibrariesReady(root, 80);
    });
  });
})();
